/* eslint-disable prefer-destructuring */

import Bottle from 'bottlejs';
import dataBottle from './userData';
import sagaBottle from './userSaga';

export default () => {
  const bottle = new Bottle();
  dataBottle(bottle);
  sagaBottle(bottle);
  return bottle;
};
